import React from 'react';
import SleepIcon from '../../images/health-content/Sleep.svg';
import rightArrow from '../../images/common/arrow-right-black.svg';
import ClockIcon from '../../images/health-content/clock-icon.svg';

import { Card, LogButton } from './common';

const SleepCard = ({ sleepCard }) => {
  function convertMinutesToHours(minutes) {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return `${hours} hrs ${remainingMinutes} mins`;
  }
  return (
    <Card className="w-half p-15 mt-2 health-card flex flex-col">
      <div>
        <div className="flex justify-between w-full">
          <img src={SleepIcon} alt="weight-icon" />
          <img src={rightArrow} alt="right-arrow" className="w-6px" />
        </div>
        <h4 className="text-caption-l font-semibold mt-10">Sleep</h4>
        <h1 className="text-title-l font-bold mt-1">
          {convertMinutesToHours(sleepCard?.current)}
        </h1>
        <p className="text-sub text-caption-s">
          Recommended: &nbsp;
          <div className="text-primary font-medium text-caption-s ">
            {convertMinutesToHours(sleepCard?.goal)}
          </div>
        </p>
      </div>
    </Card>
  );
};

export default SleepCard;
